import { render, staticRenderFns } from "./AlienMessage.vue?vue&type=template&id=0c0791f0&scoped=true&"
import script from "./AlienMessage.vue?vue&type=script&lang=ts&"
export * from "./AlienMessage.vue?vue&type=script&lang=ts&"
import style0 from "./AlienMessage.vue?vue&type=style&index=0&id=0c0791f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0791f0",
  null
  
)

export default component.exports